import { config } from "_config";

export const getApiProxyUrl = () => {
  return `${window?.location?.origin}${config.publicUrl}/crm`;
};
